import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    // Wenn wir nicht auf der Startseite sind, erst zur Startseite navigieren
    if (location.pathname !== '/') {
      navigate('/', { replace: true });
      // Kurz warten, dann scrollen
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    } else {
      // Wenn wir auf der Startseite sind, direkt scrollen
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__content">
          {/* Brand Section */}
          <div className="site-footer__brand-section">
            <Link to="/" className="site-footer__brand">
              <img
                src="/img/nintschew_logo_2.png"
                alt="Nintschew & Partner Logo"
                className="site-footer__logo"
              />
            </Link>
            <p className="site-footer__tagline">
              Strategisch. Unternehmerisch. Persönlich.
            </p>
          </div>

          {/* Quick Navigation */}
          <div className="site-footer__nav-section">
            <h4 className="site-footer__nav-title">Navigation</h4>
            <nav className="site-footer__nav">
              <button 
                className="site-footer__nav-link" 
                onClick={() => scrollToSection('about')}
              >
                Über uns
              </button>
              <button 
                className="site-footer__nav-link" 
                onClick={() => scrollToSection('services')}
              >
                Leistungen
              </button>
              <button 
                className="site-footer__nav-link" 
                onClick={() => scrollToSection('team')}
              >
                Team
              </button>
              <button 
                className="site-footer__nav-link" 
                onClick={() => scrollToSection('contact-form')}
              >
                Kontakt
              </button>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="site-footer__contact-section">
            <h4 className="site-footer__contact-title">Kontakt</h4>
            <div className="site-footer__contact-info">
              <a href="mailto:office@nintschew-partner.at" className="site-footer__email">
                office@nintschew-partner.at
              </a>
              <a href="tel:+4312880744" className="site-footer__phone">
                +43 1 288 07 44
              </a>
              <a href="https://maps.app.goo.gl/6nDLkcEyWquv5nnF6" target="_blank" rel="noopener noreferrer" className="site-footer__address">
                <div className="site-footer__address-line">
                  <span className="site-footer__pin">📍</span>
                  <span>Andreas-Huger-Gasse 6/1/49</span>
                </div>
                <div className="site-footer__address-line">
                  <span>1220 Wien, Austria</span>
                </div>
              </a>
            </div>
          </div>

          {/* Social & Legal */}
          <div className="site-footer__social-section">

            <div className="site-footer__social-links">
              <a className="site-footer__social-btn" href="https://www.facebook.com/NintschewPartner/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <img src="/img/facebook.svg" alt="Facebook" />
              </a>
              <a className="site-footer__social-btn" href="https://www.instagram.com/nintschew_partner/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <img src="/img/instagram.svg" alt="Instagram" />
              </a>
              <a className="site-footer__social-btn" href="https://www.linkedin.com/company/nintschew-partner-steuer-und-wirtschaftsberatung/?originalSubdomain=at" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <img src="/img/linkedin.svg" alt="LinkedIn" />
              </a>
            </div>
            <div className="site-footer__legal">
              <Link to="/impressum" className="site-footer__legal-link">Impressum & AAB</Link>
              <Link to="/datenschutz" className="site-footer__legal-link">Datenschutz</Link>
            </div>
          </div>
        </div>

        <hr className="site-footer__divider" />
        
        <div className="site-footer__bottom">
          <p className="site-footer__copyright">
            © 2025 Nintschew & Partner. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;